import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

const mutateDeleteVendor = async ({ id }: { id: string }) => {
  return await axiosAuth.delete(`${VENDORS}/${id}`);
};

const useDeleteVendorMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteVendor,
    ...queryParams,
  });

export default useDeleteVendorMutation;
